module.exports = __webpack_public_path__ + "img/Vector19.b0ab339e.svg";